import { TeamsSurveyTypes } from "@teams/types";
import { Location } from "history";

export const getAuthoringPath = (
  pollyType: TeamsSurveyTypes,
  location: Location<unknown>,
  options: { templateId?: string; trackingSource?: string; draftId?: string }
) => {
  const params = new URLSearchParams(location.search);

  Object.keys(options).forEach(key => {
    if (!params.has(key)) {
      params.set(key, options[key as keyof typeof options]!);
    }
  });

  return `/msteams/content/${pollyType}/authoring?${params.toString()}`;
};
